import styled from 'styled-components/macro';
import { bool } from 'prop-types';

import { rem } from '@blueprint/ui';

import { ScrollContainer } from 'components/ScrollContainer/ScrollContainer';
import {
  ONE_COLUMN_MAX_WIDTH,
  SUPPORT_PANNEL_MAX_HEIGHT,
  SUPPORT_PANNEL_MAX_WIDTH,
  SUPPORT_PANNEL_VW_WIDTH,
} from 'components/layout-dimensions';
import { colors, oneColumnLayout, twoColumnsLayout } from 'themes';

import { SupportPanel } from './SupportPanel';

const { pink, white } = colors;

const StyledDocker = styled(ScrollContainer)`
  flex-direction: column;
  padding: ${rem(20)};
  max-width: ${rem(SUPPORT_PANNEL_MAX_WIDTH)};
  height: 100vh;
  max-height: ${rem(SUPPORT_PANNEL_MAX_HEIGHT)};
  width: ${SUPPORT_PANNEL_VW_WIDTH}vw;
  flex-shrink: 0;
  opacity: 1;
  background: ${white};
  box-shadow: ${rem(2)} ${rem(2)} 0 0 rgba(0 0 0 / 35%);

  ${twoColumnsLayout} {
    border-left: ${rem(5)} solid ${pink};
    overflow-y: visible;
  }

  &&.left {
    display: none;
  }

  ${oneColumnLayout} {
    padding-right: ${rem(16)};
    padding-left: ${rem(16)};
    width: 100vw;
    max-width: ${rem(ONE_COLUMN_MAX_WIDTH)};
    max-height: unset;
    overflow-y: auto;
  }
`;

/**
 * Docker
 * top container
 */
const Docker = ({ isOpen }) => (
  <StyledDocker className={isOpen ? '' : 'left'}>
    <SupportPanel />
  </StyledDocker>
);

Docker.propTypes = {
  /**
   * checks true or false
   */
  isOpen: bool,
};

export default Docker;
